<template>
  <div class="form-dialog">
    <div class="form-body-scroll">
      <div class="form-title padding-title">
        {{ title }}
      </div>
      <div class="form-box-body">
        <div class="form-components scroll">
          <div
            class="form_combo_text"
            v-text="text"
          />
          <div
            class="form_label"
            v-text="'Tipo de producto (*)'"
          />
          <div
            id="productSelector"
            class="selectContainer"
          >
            <v-select
              v-model="dispositivo"
              class="style-chooser"
              :reduce="device => device.value"
              :options="deviceOptions"
              label="name"
              :clearable="false"
            />
          </div>
          <div
            class="form_label"
            v-text="'Ingrese su nombre completo (*)'"
          />
          <div class="form__field">
            <label
              for="nombre"
            >
              <v-icon
                name="user"
                scale="1"
                style="margin: 1px 1px 0"
              />
            </label>
            <input
              id="nombre"
              ref="nombre"
              v-model="nombre"
              autocomplete="off"
              type="text"
              name="nombre"
              value=""
              placeholder="Nombre completo"
              required
              @focus="_clearError"
              @keypress="keyPressCheckSpecialChars($event, 'name')"
              @change="cleanSpecialChars('nombre', 'name')"
            >
          </div>
          <div
            class="form_label"
            v-text="'Tipo de documento de identidad (*)'"
          />
          <div
            id="documentSelector"
            class="selectContainer"
          >
            <v-select
              v-model="cmbIdentidad"
              class="style-chooser"
              :reduce="documento => documento.value"
              :options="documentOptions"
              label="name"
              :clearable="false"
            />
          </div>

          <div v-if="cmbIdentidad === 'dni'">
            <div
              class="form_label"
              v-text="'Ingrese su RUT (*)'"
            />
            <div class="form__field">
              <label
                for="rut"
              >
                <v-icon
                  name="id-card"
                  scale="1"
                  style="margin: 1px 1px 0"
                />
              </label>
              <input
                id="rut"
                ref="rut"
                v-model="rut"
                autocomplete="off"
                type="text"
                name="rut"
                value=""
                placeholder="RUT (sin puntos ni guión)"
                required
                @focus="_clearError"
                @keyup.enter="focusTo('direccion')"
                @keypress="keyPressCheckSpecialChars($event, 'rut')"
                @change="_formatearRut($event.target.value)"
              >
            </div>
          </div>
          <div v-else-if="cmbIdentidad === 'passport'">
            <div
              class="form_label"
              v-text="'Ingrese su N° de Pasaporte (*)'"
            />
            <div class="form__field">
              <label
                for="passportID"
              >
                <v-icon
                  name="id-card"
                  scale="1"
                  style="margin: 1px 1px 0"
                />
              </label>
              <input
                id="passportID"
                ref="passportID"
                v-model="pasaporteID"
                autocomplete="off"
                type="text"
                name="passportID"
                value=""
                placeholder="N° Pasaporte"
                required
                @focus="_clearError"
                @keyup.enter="focusTo('direccion')"
              >
            </div>
          </div>

          <div
            class="form_label"
            v-text="'Ingrese su dirección (*)'"
          />
          <div class="form__field">
            <label
              for="direccion"
            >
              <v-icon
                name="home"
                scale="1"
                style="margin: 1px 1px 0"
              />
            </label>
            <input
              id="direccion"
              ref="direccion"
              v-model="direccion"
              autocomplete="off"
              type="text"
              name="direccion"
              value=""
              placeholder="Dirección"
              required
              @focus="_clearError"
              @keyup.enter="focusTo('email')"
            >
          </div>
          <div
            class="form_label"
            v-text="'Ingrese su correo electrónico (*)'"
          />
          <div class="form__field">
            <label
              for="email"
            ><v-icon
              name="envelope"
              scale="1"
              style="margin-top: 2px"
            /></label>
            <input
              id="email"
              ref="email"
              v-model="email"
              class="email"
              autocomplete="off"
              type="text"
              name="email"
              value=""
              placeholder="usuario@dominio.com"
              required
              @focus="_clearError"
              @keyup.enter="focusTo('telefono')"
              @keypress="keyPressCheckSpecialChars($event, 'email')"
              @change="cleanSpecialChars('email', 'email')"
            >
          </div>

          <div
            class="form_label"
            v-text="'Ingrese su teléfono (*)'"
          />
          <div class="form__field">
            <label
              for="telefono"
            >
              <v-icon
                name="mobile-alt"
                scale="1"
                style="margin: 1px 2px 0 4px"
              />
            </label>
            <input
              id="telefono"
              ref="telefono"
              v-model="telefono"
              autocomplete="off"
              type="text"
              name="telefono"
              value=""
              placeholder="9 1234 5678"
              required
              @focus="_clearError"
              @keyup.enter="focusTo('deviceModel')"
              @keypress="keyPressCheckSpecialChars($event, 'phone')"
              @change="cleanSpecialChars('telefono', 'phone')"
            >
          </div>

          <div
            class="form_label"
            v-text="'Ingrese el modelo de su dispositivo (*)'"
          />
          <div class="form__field">
            <label
              for="deviceModel"
            >
              <v-icon
                name="memory"
                scale="1"
                style="margin: 1px 1px 0"
              />
            </label>
            <input
              id="deviceModel"
              ref="deviceModel"
              v-model="modeloDispositivo"
              autocomplete="off"
              type="text"
              name="deviceModel"
              value=""
              placeholder="Modelo"
              required
              @focus="_clearError"
              @keyup.enter="focusTo('serialNumber')"
            >
          </div>

          <div
            class="form_label"
          >
            <label>Ingrese <b>IMEI(*)</b> o Número de serie</label>
          </div>
          <div class="form__field">
            <label
              v-tooltip="'Para obtener el IMEI digite#06# o búsquelo en la caja del producto.'"
              for="serialNumber"
            >
              <v-icon
                name="info-circle"
                scale="1"
                style="margin: 1px 2px 0 4px"
              />
            </label>
            <input
              id="serialNumber"
              ref="serialNumber"
              v-model="numeroSerie"
              autocomplete="off"
              type="text"
              name="serialNumber"
              value=""
              placeholder="1234 5678 90"
              required
              @focus="_clearError"
              @keyup.enter="focusTo('comentario')"
              @keypress="keyPressCheckSpecialChars($event, 'phone')"
              @change="cleanSpecialChars('telefono', 'phone')"
            >
          </div>

          <div class="form_label">
            Descripción detallada de la falla (*)
          </div>
          <div class="score-comments">
            <textarea
              id="comentario"
              ref="comentario"
              v-model="comentario"
              style="white-space: pre-line"
              placeholder="Describanos el problema..."
            />
          </div>
        </div>
      </div>
      <!-- BOTONES -->
      <div class="form-box-button scroll margin_btn btn_forms">
        <button
          class="button-secondary"
          @click="_cancelClick"
        >
          Cancelar
        </button>
        <button
          class="button-primary"
          @click="_sentClick"
        >
          Enviar
        </button>
      </div>
      <!-- MSG -->
      <div class="form-error">
        &nbsp;{{ errormsg }}
      </div>
    </div>
  </div>
</template>
<script>
import { serverUI } from '../../main'
import Icon from 'vue-awesome/components/Icon'
import 'vue-awesome/icons/user'
import 'vue-awesome/icons/envelope'
import 'vue-awesome/icons/shipping-fast'
import 'vue-awesome/icons/id-card'
import 'vue-awesome/icons/mobile'
import 'vue-awesome/icons/barcode'
import 'vue-awesome/icons/info-circle'
import 'vue-awesome/icons/info'
import 'vue-awesome/icons/home'
import 'vue-awesome/icons/memory'
import formUtils from '../../formUtils'
import utils from '../../utils'
import VueSelect from 'vue-select'
import 'vue-select/dist/vue-select.css'

export default {
  components: {
    'v-icon': Icon,
    'v-select': VueSelect
  },
  props: {},
  methods: {
    ...formUtils.formBase,
    _sentClick () {
      this.errormsg = ''
      if (!this.dispositivo) {
        this.errormsg = 'Debes seleccionar el tipo de producto'
        return
      }
      if (!this.nombre || this.nombre === 'Visita' || this.nombre === '') {
        this.errormsg = 'Debes ingresar tu nombre'
        return
      }
      if (!this.cmbIdentidad) {
        this.errormsg = 'Debes ingresar un tipo de documento de identidad'
        return
      }
      if (this.cmbIdentidad === 'dni' && !this.rut) {
        this.errormsg = 'Debe ingresar su rut'
        return
      }
      if (this.cmbIdentidad === 'dni' && !utils.validaRut(this.rut)) {
        this.errormsg = 'Debe ingresar un rut valido'
        return
      }
      if (this.cmbIdentidad === 'passport' && !this.pasaporteID) {
        this.errormsg = 'Debe ingresar el numero de su pasaporte'
        return
      }
      if (!this.direccion) {
        this.errormsg = 'Debes ingresar una dirección'
        return
      }
      if (!this.email) {
        this.errormsg = 'Debes ingresar email'
        return
      }
      if (!utils.isEmail(this.email)) {
        this.errormsg = 'Formato email incorrecto'
        return
      }
      if (!this.telefono) {
        this.errormsg = 'Debes ingresar el teléfono'
        return
      }
      if (!this.modeloDispositivo) {
        this.errormsg = 'Debes indicar el modelo de tu equipo'
        return
      }
      if (!this.numeroSerie) {
        this.errormsg = 'Debes indicar el IMEI o n° de serie de tu equipo'
        return
      }
      if (!this.comentario) {
        this.errormsg = 'Debe ingresar un detalle del problema'
        return
      }
      const dataToSend = {
        form: 'RealmeTechnicalServiceForm',
        evento: 'sentClick',
        data: {
          type: 'realme-form-technical-service-confirm',
          fields: {
            device: this.dispositivo,
            name: this.nombre,
            rut: this.rut || '-',
            passport: this.pasaporteID || '-',
            address: this.direccion,
            phone: this.telefono,
            email: this.email,
            deviceModel: this.modeloDispositivo,
            serialNumber: this.numeroSerie,
            comment: this.comentario
          }
        }
      }

      serverUI.$emit('FormEvent', dataToSend)
    },
    _formatearRut (val) {
      this.rut = utils.cleanSpecialChars(val, 'rut')
      this.rut = utils.formatearRut(this.rut)
    },
    _cancelClick () {
      serverUI.$emit('FormEvent', {
        form: 'RealmeTechnicalServiceForm',
        evento: 'cancelClick',
        dato: 'Cancelado'
      })
    }
  },
  data () {
    return {
      title: '',
      text: '',
      errormsg: '',
      nombre: '',
      direccion: '',
      rut: '',
      cmbIdentidad: '',
      pasaporteID: '',
      telefono: '',
      email: '',
      dispositivo: '',
      modeloDispositivo: '',
      numeroSerie: '',
      comentario: ''
    }
  },
  computed: {
    deviceOptions () {
      return [
        {
          value: '',
          name: 'Seleccionar'
        },
        {
          value: 'celulares',
          name: 'Celulares'
        },
        {
          value: 'audifonos',
          name: 'Audifonos'
        }
      ]
    },
    documentOptions () {
      return [
        {
          value: '',
          name: 'Seleccionar'
        },
        {
          value: 'dni',
          name: 'Cedula de identidad'
        },
        {
          value: 'passport',
          name: 'Pasaporte'
        }
      ]
    }
  },
  created () {
    // Señales recibidas
    serverUI.$on('FormEvent', (e) => {
      if (e.form !== 'RealmeTechnicalServiceForm') return
      if (e.evento === 'newdata') {
        this.text = e.dato.text ? e.dato.text : ''
        this.title = e.dato.title ? e.dato.title : 'Formulario Servicio Tecnico'
        this.nombreOrigen = e.dato.fields.name ? e.dato.fields.name : ''
        this.emailOrigen = e.dato.fields.email ? e.dato.fields.email : ''
        this.telefonoOrigen = e.dato.fields.phone
          ? e.dato.fields.phone
          : ''
        this.nombre = this.nombreOrigen
        this.email = this.emailOrigen
        this.telefono = this.telefonoOrigen
      }
    })
  }
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style lang="scss" scoped>
.form__field {
	margin-bottom: 7px;
}

.form-box-body {
	height: 335px;
}
</style>

<style scoped>
.style-chooser {
  --vs-controls-color: black;
  --vs-border-color: #ffc915;

  --vs-dropdown-bg: #ffc915;
  --vs-dropdown-color: black;
  --vs-dropdown-option-color: black;

  --vs-selected-bg: #664cc3;
  --vs-selected-color: black;

  --vs-search-input-color: #eeeeee;

  --vs-dropdown-option--active-bg: #23bad3;
  --vs-dropdown-option--active-color: #eeeeee;
}
</style>
